import React, { useEffect, useState } from "react";
import {
  getFaqs,
  addFaq,
  updateFaq,
  deleteFaq,
} from "../../lib/firebase/firestore";

// Firebase services
import {
  getHomePageData,
  updateHomePageData,
} from "../../lib/firebase/firestore";
import { HomePageData } from "../../types";

export const EditSettingsPage = () => {
  //const navigate = useNavigate();
  const [formData, setFormData] = useState<HomePageData>({
    hero: {
      title: "",
      subtitle: "",
      backgroundImage: "",
    },
    featured: {
      title: "",
      description: "",
      image: "",
    },
  });

  const [loadingHero, setLoadingHero] = useState(false);
  const [loadingFeatured, setLoadingFeatured] = useState(false);
  const [faqs, setFaqs] = useState<
    { id?: string; question: string; answer: string }[]
  >([]);
  const [newFaq, setNewFaq] = useState({ question: "", answer: "" });
  // Load homepage data

  useEffect(() => {
    const loadSettings = async () => {
      const data = await getHomePageData();
      if (data) setFormData(data);
    };

    loadSettings();
  }, []);

  // Load FAQs
  useEffect(() => {
    const fetchFaqs = async () => {
      const data = await getFaqs();
      setFaqs(data);
    };
    fetchFaqs();
  }, []);

  const handleChange = (
    section: keyof HomePageData,
    field: string,
    value: string,
  ) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));
  };
  const handleAddFaq = async () => {
    if (!newFaq.question || !newFaq.answer)
      return alert("Please fill both fields");
    await addFaq(newFaq);
    setNewFaq({ question: "", answer: "" });
    const data = await getFaqs();
    setFaqs(data);
  };

  const handleUpdateFaq = async (
    id: string,
    question: string,
    answer: string,
  ) => {
    await updateFaq(id, { question, answer });
    const data = await getFaqs();
    setFaqs(data);
  };

  const handleDeleteFaq = async (id: string) => {
    await deleteFaq(id);
    const data = await getFaqs();
    setFaqs(data);
  };

  const handleSaveHero = async () => {
    setLoadingHero(true);
    try {
      await updateHomePageData(formData);
      alert("Hero updated successfully!");
    } catch (error) {
      console.error("Error updating hero:", error);
      alert("Failed to update hero");
    }
    setLoadingHero(false);
  };

  const handleSaveFeatured = async () => {
    setLoadingFeatured(true);
    try {
      await updateHomePageData(formData);
      alert("Featured project updated successfully!");
    } catch (error) {
      console.error("Error updating featured:", error);
      alert("Failed to update featured");
    }
    setLoadingFeatured(false);
  };

  return (
    <div style={{ padding: "2rem" }}>
      <h2>Edit Homepage Settings</h2>

      {/* Hero Section */}
      <section
        style={{
          marginBottom: "3rem",
          borderBottom: "1px solid #ccc",
          paddingBottom: "2rem",
        }}
      >
        <h3>Hero Section</h3>
        <input
          placeholder="Title"
          value={formData.hero.title}
          onChange={(e) => handleChange("hero", "title", e.target.value)}
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />
        <textarea
          placeholder="Subtitle"
          value={formData.hero.subtitle}
          onChange={(e) => handleChange("hero", "subtitle", e.target.value)}
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />
        <input
          placeholder="Hero Background Image URL"
          value={formData.hero.backgroundImage}
          onChange={(e) =>
            handleChange("hero", "backgroundImage", e.target.value)
          }
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />

        <button
          type="button"
          onClick={handleSaveHero}
          disabled={loadingHero}
          style={{
            backgroundColor: "#000",
            color: "#fff",
            border: "none",
            padding: "0.75rem 1.5rem",
            cursor: "pointer",
            borderRadius: "9999px",
          }}
        >
          {loadingHero ? "Saving..." : "Save Hero"}
        </button>
      </section>

      {/* Featured Project Section */}
      <section style={{ marginBottom: "3rem" }}>
        <h3>Featured Project</h3>
        <input
          placeholder="Featured Title"
          value={formData.featured.title}
          onChange={(e) => handleChange("featured", "title", e.target.value)}
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />
        <textarea
          placeholder="Featured Description"
          value={formData.featured.description}
          onChange={(e) =>
            handleChange("featured", "description", e.target.value)
          }
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />
        <input
          placeholder="Featured Image URL"
          value={formData.featured.image}
          onChange={(e) => handleChange("featured", "image", e.target.value)}
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />

        <button
          type="button"
          onClick={handleSaveFeatured}
          disabled={loadingFeatured}
          style={{
            backgroundColor: "#000",
            color: "#fff",
            border: "none",
            padding: "0.75rem 1.5rem",
            cursor: "pointer",
            borderRadius: "9999px",
          }}
        >
          {loadingFeatured ? "Saving..." : "Save Featured Project"}
        </button>
      </section>

      {/* === FAQ Section === */}
      <section
        style={{
          marginTop: "3rem",
          borderTop: "1px solid #ccc",
          paddingTop: "2rem",
        }}
      >
        <h3>FAQ Management</h3>

        {/* Add FAQ */}
        <div style={{ marginBottom: "1.5rem" }}>
          <input
            type="text"
            placeholder="Question"
            value={newFaq.question}
            onChange={(e) =>
              setNewFaq((prev) => ({ ...prev, question: e.target.value }))
            }
            style={{ width: "100%", marginBottom: "0.5rem", padding: "0.5rem" }}
          />
          <textarea
            placeholder="Answer"
            value={newFaq.answer}
            onChange={(e) =>
              setNewFaq((prev) => ({ ...prev, answer: e.target.value }))
            }
            style={{ width: "100%", marginBottom: "0.5rem", padding: "0.5rem" }}
          />
          <button
            type="button"
            onClick={handleAddFaq}
            style={{
              backgroundColor: "#000",
              color: "#fff",
              padding: "0.5rem 1rem",
              border: "none",
              borderRadius: "8px",
            }}
          >
            Add FAQ
          </button>
        </div>

        {/* List FAQs */}
        {faqs.map((faq) => (
          <div
            key={faq.id}
            style={{
              marginBottom: "1rem",
              padding: "1rem",
              border: "1px solid #ddd",
              borderRadius: "8px",
            }}
          >
            <input
              type="text"
              value={faq.question}
              onChange={(e) =>
                setFaqs((prev) =>
                  prev.map((f) =>
                    f.id === faq.id ? { ...f, question: e.target.value } : f,
                  ),
                )
              }
              style={{
                width: "100%",
                marginBottom: "0.5rem",
                padding: "0.5rem",
              }}
            />
            <textarea
              value={faq.answer}
              onChange={(e) =>
                setFaqs((prev) =>
                  prev.map((f) =>
                    f.id === faq.id ? { ...f, answer: e.target.value } : f,
                  ),
                )
              }
              style={{
                width: "100%",
                marginBottom: "0.5rem",
                padding: "0.5rem",
              }}
            />
            <button
              onClick={() => handleUpdateFaq(faq.id!, faq.question, faq.answer)}
              style={{
                marginRight: "0.5rem",
                backgroundColor: "green",
                color: "#fff",
                padding: "0.5rem 1rem",
                border: "none",
                borderRadius: "6px",
              }}
            >
              Save
            </button>
            <button
              onClick={() => handleDeleteFaq(faq.id!)}
              style={{
                backgroundColor: "red",
                color: "#fff",
                padding: "0.5rem 1rem",
                border: "none",
                borderRadius: "6px",
              }}
            >
              Delete
            </button>
          </div>
        ))}
      </section>
    </div>
  );
};
